import { mat4 } from "gl-matrix";
import { Camera } from "../../../../SharedGL/Camera";
import { IRGBA } from "../../TimelineUtils";
import { HighlightedFlightShader } from "./HighlightedFlightShader";

interface IFlightGLAttributes {
  position: WebGLBuffer;
}

export interface IHighlighColors {
  fill: IRGBA;
  outline: IRGBA;
}

export class HighlightedFlightGL {
  public static readonly referenceTime = new Date().getTime(); //Date.now();

  private flightShader: HighlightedFlightShader;

  private buffers: IFlightGLAttributes;

  private positions: number[];

  constructor(gl: WebGLRenderingContext, color: IRGBA) {
    // super(gl);
    // Initialize a shader program; this is where all the lighting
    // for the vertices and so forth is established.

    // this.labelShaderProgram = initShaderProgram(gl, this.vsSource, this.fsSource);
    this.flightShader = new HighlightedFlightShader(gl);

    // Here's where we call the routine that builds all the
    // objects we'll be drawing.
    this.buffers = this.initBuffers(gl);
  }

  //
  // initBuffers
  //
  // Initialize the buffers we'll need. For this demo, we just
  // have one object -- a simple two-dimensional square.
  //
  protected initBuffers = (gl: WebGLRenderingContext): IFlightGLAttributes => {
    // Create a buffer for the square's positions.

    const positionBuffer = gl.createBuffer();

    // Select the positionBuffer as the one to apply buffer
    // operations to from here out.

    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);

    // Now create an array of positions for the square.
    const y0 = 0; // FlightGL.actualDepartureStart + rowStart; // this.aircraftActualFlightHeight;
    const y = 1; // FlightGL.actualDepartureHeight;// FlightGL.actualDepartureHeight; // rowStart + totalHeight -  FlightGL.aircraftRowPadding;
    const x0 = 0; // flight.x0 - Camera.referenceTime;
    const x = 1; // flight.x - Camera.referenceTime;
    this.positions = [
      x0,
      y0,
      x,
      y0,
      x,
      y,
      x0,
      y,

      //Filled
      x0,
      y,
      x0,
      y0,
      x,
      y,
      x,
      y0,
    ];

    // this.position(...flightPositions);

    // Now pass the list of positions into WebGL to build the
    // shape. We do this by creating a Float32Array from the
    // JavaScript array, then use it to fill the current buffer.

    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(this.positions), gl.STATIC_DRAW);

    return {
      position: positionBuffer,
    };
  };

  public drawHighlightedFlight = (
    gl: WebGLRenderingContext,
    camera: Camera,
    timePos: number[],
    yPos: number[],
    color: IHighlighColors
  ): void => {
    const vertexCount = this.positions.length / 2.0;
    if (vertexCount === 0 || timePos.length !== 2) {
      return;
    }

    this.flightShader.bindPositionsBuffer(gl, this.buffers.position);

    const modelViewMatrix = mat4.create();

    /*Actual departure/arrival */
    const [minTime, maxTime] = timePos;
    const x0 = minTime - Camera.referenceTime;
    const x = maxTime - Camera.referenceTime;
    const width = x - x0;

    const [yStart, height] = yPos;
    mat4.translate(
      modelViewMatrix, // destination matrix
      modelViewMatrix, // matrix to translate
      [x0, yStart, -1.0]
    ); // amount to translate
    mat4.scale(modelViewMatrix, modelViewMatrix, [width, height, 1.0]);

    this.flightShader.setModelViewMatrix(gl, modelViewMatrix);

    // Outline
    this.flightShader.setColorUniform(gl, color.outline);
    this.flightShader.draw(gl, camera, 0, 4, "OUTLINE");
    // Fill
    this.flightShader.setColorUniform(gl, color.fill);
    this.flightShader.draw(gl, camera, 4, 4, "FILL");
  };
}
